import { useContext, useLayoutEffect } from 'react';

import useGoBack from '@/hooks/useGoBack';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';

import Heading from './Heading';
import SettingsHeadingContext from './SettingsHeadingContext';

import './styles/SettingsHeading.css';

export default function SettingsHeading({ text, to=null, action=null }) {
  const settingsHeadingContext = useContext(SettingsHeadingContext);
  const fallbackRoute = to ? to : "/profile/settings";
  const goBackHandler = useGoBack(fallbackRoute);

  useLayoutEffect(() => {
    if (!settingsHeadingContext) {
      return undefined;
    }

    settingsHeadingContext.setHeading({ text, to, action });
    return () => {
      settingsHeadingContext.setHeading((currentHeading) => {
        if (currentHeading?.text === text && currentHeading?.to === to && currentHeading?.action === action) {
          return { text: '', to: null, action: null };
        }

        return currentHeading;
      });
    };
  }, [action, settingsHeadingContext, text, to]);

  if (settingsHeadingContext) {
    return null;
  }

  return (
    <>
      <div className="settings-heading__container">
        <BackArrowIcon className="settings-heading__back" onClick={goBackHandler}/>
        <Heading className="settings-heading__text">{text}</Heading>
        {action ? (
          <div className="settings-heading__action">
            {action}
          </div>
        ) : null}
      </div>
    </>
  );
}
